import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TableModule } from 'primeng/table';
import { Tabs, TabList, Tab } from 'primeng/tabs';
import { CommonModule } from '@angular/common';
import { MonthlyReportData } from '@features/reports/models/results.model';
import sourcesData from '@assets/data/sources.json';

@Component({
  selector: 'app-results-by-month-list',
  imports: [TableModule, Tabs, TabList, Tab, CommonModule],
  templateUrl: './results-by-month-list.html',
  styleUrl: './results-by-month-list.scss'
})
export class ResultsByMonthList {
  @Input() dataScope: MonthlyReportData | null = null;
  @Input() dataCategory: MonthlyReportData | null = null;

  activeTabIndex: number = 0;
  monthsColumns = [
    { field: 'jan', header: 'Enero' },
    { field: 'feb', header: 'Febrero' },
    { field: 'mar', header: 'Marzo' },
    { field: 'apr', header: 'Abril' },
    { field: 'may', header: 'Mayo' },
    { field: 'jun', header: 'Junio' },
    { field: 'jul', header: 'Julio' },
    { field: 'aug', header: 'Agosto' },
    { field: 'sep', header: 'Septiembre' },
    { field: 'oct', header: 'Octubre' },
    { field: 'nov', header: 'Noviembre' },
    { field: 'dec', header: 'Diciembre' }
  ];

  get displayData(): any[] {
    const currentData = this.activeTabIndex === 0 ? this.dataScope : this.dataCategory;
    if (!currentData || !currentData.groups) {
      return [];
    }

    const result: any[] = [];
    currentData.groups.forEach(group => {
      // Agregar fila de header de grupo
      result.push({ isGroupHeader: true, groupKey: group.groupName });

      // Filas de fuentes
      group.sources.forEach(source => {
        const rawName = source.sourceName;
        const translation = (sourcesData.variations as Record<string, string>)[rawName];
        const sourceName = translation || rawName;

        result.push({
          sourceName: sourceName,
          jan: source.monthlyValues.jan,
          feb: source.monthlyValues.feb,
          mar: source.monthlyValues.mar,
          apr: source.monthlyValues.apr,
          may: source.monthlyValues.may,
          jun: source.monthlyValues.jun,
          jul: source.monthlyValues.jul,
          aug: source.monthlyValues.aug,
          sep: source.monthlyValues.sep,
          oct: source.monthlyValues.oct,
          nov: source.monthlyValues.nov,
          dec: source.monthlyValues.dec,
          sourceTotal: source.sourceTotal
        });
      });

      // Agregar fila de totales del grupo
      result.push({ isTotal: true, totals: group.groupTotals, groupName: group.groupName });
    });

    // Agregar fila de gran total al final
    if (currentData.grandTotal) {
      result.push({ isGrandTotal: true, totals: currentData.grandTotal });
    }

    return result;
  }

  isGroupHeader(row: any): boolean {
    return row?.isGroupHeader === true;
  }

  isTotal(row: any): boolean {
    return row?.isTotal === true;
  }

  isGrandTotal(row: any): boolean {
    return row?.isGrandTotal === true;
  }
}
